"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NotificationTimed_1 = require("./NotificationTimed");
exports.default = NotificationTimed_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/NotificationTimed/index.js
// module id = 1790
// module chunks = 8